/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import bgMainheader from "../LaunchPool/images/banner-ino.png";
import './style.css'
import Stake from "./Stake";
import UnStake from "./Unstake";
import Withdraw from "./Withdraw";
import { useContract } from "../../hooks/useContract";
import abiStake from "./utils/abiStake.json"
import Web3 from "web3";
import { AbiItem } from "web3-utils";
import { useAccount } from "wagmi";
import { SC_STAKE_BSCS } from "components/constants";

const StakePoolV2 = () => {
    const { poolContract } = useParams();
    let navigate = useNavigate();
    let location = useLocation();
    const { TabPane } = Tabs;
    const [defaultKey, setDefaultKey] = useState("stake");
    const pathTabsLive = location.search.split("?");
    const tabBox = pathTabsLive[1] === undefined ? "stake" : pathTabsLive[1];
    const [isPoolInfinity, setIsPoolInfinity]: any = useState(false);
    const { address } = useAccount();

    let account = address
    const contractStake: any = useContract(poolContract, abiStake);

    let web3: any = new Web3('https://bsc-dataseed4.defibit.io');
    const [totalStaked, setTotalStaked]: any = useState(0)
    const [numberStaked, setNumberStaked]: any = useState(0)
    const [isCheckAction, setIsCheckAction]: any = useState(false)
    const [contractStake1, setContractStake1] = useState<any>(null);
    const [apy, setApy]: any = useState(0);

    useEffect(() => {
        if (poolContract) {
            if (poolContract?.toLowerCase() === SC_STAKE_BSCS?.toLowerCase()) {
                setIsPoolInfinity(true)
            } else {
                setIsPoolInfinity(false)
            }
        }

    }, [poolContract])




    useEffect(() => {
        if (!web3.utils.isAddress(poolContract)) {
            navigate('/launch-pool');
            return;
        }
        const contract = new web3.eth.Contract(
            abiStake as unknown as AbiItem,
            poolContract
        );
        setContractStake1(contract);
    }, [poolContract, navigate]);

    function callback(key: any) {
        setDefaultKey(key);
        navigate(`/launch-pool-details/${poolContract}?${key}`);
    }

    useEffect(() => {
        if (tabBox) {
            setDefaultKey(tabBox);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabBox]);

    // const getBscs = async () => {
    //     if (bscsContract) {
    //         const amount = await bscsContract.balanceOf(SC_STAKE_BSCS);
    //         setTotalStaked(amount.toString() / 1e18);
    //     } else {
    //         setTotalStaked(0)
    //     }
    // };

    // console.log('contractStake', contractStake)
    // console.log('contractStake1', contractStake1)

    const getAPY = async () => {
        await contractStake1.methods.stakeRewardAPY().call()
            .then((res: any) => {
                setApy(res);
            })
            .catch((err: any) => {
                setApy(0);
            });
    };

    const getTotalStaked = async () => {
        // await contractStake.tokenTotalStaked().then((res: any) => {
        //     setTotalStaked(res / 1e18)
        // })
        //     .catch((err: any) => {
        //         console.log('err', err)
        //         setTotalStaked(0)
        //     })
        await contractStake1.methods.tokenTotalStaked().call()
            .then((res: any) => {
                // console.log('res11------', res)
                setTotalStaked(res / 1e18)
            })
            .catch((err: any) => {
                // console.log('err11-------', err)
                setTotalStaked(0)
            })

    }

    const getNumberStaked = async () => {
        try {
            // await contractStake.stakerCount().then((res: any) => {

            //     setNumberStaked(Number(res))
            // })
            //     .catch((err: any) => {
            //         setNumberStaked(0)
            //         console.log('err', err)
            //     })

            await contractStake1.methods.stakerCount().call()
                .then((res: any) => {
                    // console.log('res22------', res)
                    setNumberStaked(Number(res))
                })
                .catch((err: any) => {
                    // console.log('err22-------', err)
                    setNumberStaked(0)
                })

        } catch (error) {

        }

    }
    useEffect(() => {
        if (contractStake1) {
            getNumberStaked()
        }

    }, [contractStake, isCheckAction, poolContract, contractStake1]);

    useEffect(() => {

        if (contractStake1) {
            getTotalStaked()
            getAPY()
        }
    }, [account, contractStake, isCheckAction, poolContract, contractStake1]);



    const formatNumber = (x: any, max: any) => {
        if (x) {
            return x.toLocaleString("en-US", {
                minimumFractionDigits: 1,
                maximumFractionDigits: max,
            });
        } else return 0;
    };

    return (
        <>
            <div
                className="main-stake-pool-v2"
                style={{
                    background: `url(${bgMainheader}) 0% 50% / cover no-repeat`,
                }}
            >
                <div className="container-stake">
                    <div className="big-title">Launch Pool</div>
                    <div className="item-info">
                        <div className="item-1">
                            <div className="title-item">Number of Stakers</div>
                            {isPoolInfinity ? (
                                <div className="num-item">{numberStaked + 2000}</div>
                            ) : (
                                <div className="num-item">{numberStaked}</div>
                            )}

                        </div>
                        <div className="item-1">
                            <div className="title-item">Total BSCS Staked</div>
                            {totalStaked && totalStaked > 0 ? (
                                // <div className="num-item">{totalStaked} BSCS</div>
                                <div className="num-item">{formatNumber(totalStaked, 4)} BSCS</div>
                            ) : (
                                <div className="num-item">0 BSCS</div>
                            )}

                        </div>
                        <div className="item-1">
                            <div className="title-item">APY</div>
                            <div className="num-item">{apy}%</div>
                        </div>
                    </div>

                    <div className="tabs-stake-pool v2">
                        <Tabs activeKey={defaultKey} onChange={callback}>
                            <TabPane tab="Stake" key="stake">
                                <Stake tabBox={tabBox} setIsCheckAction={setIsCheckAction} isCheckAction={isCheckAction} />
                            </TabPane>
                            <TabPane tab="Unstake" key="unstake">
                                <UnStake tabBox={tabBox} setIsCheckAction={setIsCheckAction} isCheckAction={isCheckAction} />
                            </TabPane>
                            <TabPane tab="Withdraw" key="withdraw">
                                <Withdraw tabBox={tabBox} setIsCheckAction={setIsCheckAction} isCheckAction={isCheckAction} />
                            </TabPane>
                        </Tabs>
                    </div>
                </div>
            </div>
        </>
    )
}

export default StakePoolV2;
